import Itinerary from "@/components/CurrentTrip/NewItinerary/Itinerary";
import Travelers from "@/components/Users/Travelers";
import Cities from "@/components/CurrentTrip/Cities/Cities";
import Surveys from "@/components/CurrentTrip/Surveys/Surveys";
import Contacts from "@/components/CurrentTrip/Contacts";
import Settings from "@/components/CurrentTrip/Settings";
import Training from "@/components/CurrentTrip/Training";
import Feed from "@/components/CurrentTrip/Feed/Feed";
import Files from "@/components/CurrentTrip/Files/Files";
import Chat from "@/components/CurrentTrip/Chat/Chat";
import Reviews from "@/components/CurrentTrip/Reviews/Reviews";
import Trip from '../views/CurrentTrip';
import store from '../store/index';
import Subgroup from "../components/CurrentTrip/Subgroup/Subgroup";

export default {
  path: '/trip',
  name: 'Trip',
  props: true,
  component: Trip,
  children: [
    { path: '', component: Itinerary },
    { name: 'Itinerary', path: 'itinerary', component: Itinerary },
    { path: 'travelers/:type', component: Travelers, props: true },
    { path: 'cities', component: Cities },
    { path: 'surveys', component: Surveys },
    { path: 'contacts', component: Contacts },
    { path: 'settings', component: Settings },
    { path: 'reviews', component: Reviews },
    { path: 'training', component: Training },
    { path: 'feed', component: Feed },
    {
      path: 'chat',
      component: Chat,
      name: "chat",
      props: true,
    },
    { path: 'files', component: Files },
    { path: 'subgroups', component: Subgroup },

  ],
  // router.push({ path: 'foo', append: true })

  beforeEnter: ((to, from, next) => {
    console.log("before enter trip");
    console.log(to);
    if (to.params.tripId || store.state.trip.trip != null) {
      console.log("going next with no prob");
      next();
    } else {
      next({ name: 'Trips' });
    }
  }),
};
